import { RootState } from "@/store/store";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";
import { selectedResourcesByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesByMasterIdSelector";

export const cleanDisabledForSelectedResourcesByMasterIdSelector = (
  state: RootState,
  masterGridId: string,
) => {
  const selectedResources = selectedResourcesByMasterIdSelector(
    state,
    masterGridId,
  );

  const excludedItemsCount = selectedResources?.reduce((result, resource) => {
    if (!resource) {
      return result;
    }

    const accessType = isResourceKubernetes(resource)
      ? "read"
      : resource.account.provider_access_type;

    if (
      accessType === "read" ||
      resource.marked_for_deletion ||
      resource.is_protected
    ) {
      result++;
    }

    return result;
  }, 0);

  return excludedItemsCount === selectedResources?.length;
};
